import request from './request';
import deserialize from './deserialize';

export type KioskCodes = {
  id: string;
  code: string;
  deepLink: string;
  createdAt: number;
  expiresAt: number;
  updatedAt: number;
};

interface GenerateAttrs {
  companyId: string;
  storeId: string;
  slotNumber: number;
}

export function generate(attrs: GenerateAttrs) {
  const { companyId, storeId, slotNumber } = attrs;

  return request<KioskCodes>({
    url: `/companion/v1/companies/${companyId}/stores/${storeId}/generate/kiosk/code`,
    method: 'POST',
    data: {
      data: {
        attributes: {
          slotNumber,
        },
      },
    },
    transformResponse: deserialize,
  });
}
